module.exports = __webpack_public_path__ + "img/search_03.b74fe800.png";